import React, { useState, useEffect } from "react";
import ProfileCard from "./profile-card";
import axios from "axios";
import Header from "../common/header/Header";
import { ENDPOINTS } from "../../js/api/_config";

import { BackButton } from "../common/back-button/back-button";
import ImageUploaderUrl from "../common/image-upload-url/image-upload-url";
import { Toast } from "../common/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducer/slices/user/userSlice";
import { set } from "date-fns";

const EditPersonalInfo = () => {
  const userData = useSelector((state) => state.user);
  const [userProfile, setUserProfile] = useState(userData.userProfile);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(true);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Image Uploaded
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileUploadData, setFileUploadData] = useState();
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [apiLoader, setApiLoader] = useState(false);
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    dispatch(fetchUserProfile({}));
  }, []);

  useEffect(() => {
    if (userProfile && !userProfile.userID && !userData.isLoading) {
      setUserProfile(userData.userProfile);
      setIsLoading(userData.isLoading);
    }else{
      setIsLoading(userData.isLoading);
    }
  }, [userData]);

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const validate = () => {
    const newErrors = {};
    if (!userProfile.firstName) {
      newErrors.firstName = "First Name is required.";
    }
    if (!userProfile.lastName) {
      newErrors.lastName = "Last Name is required.";
    }
    if (!userProfile.phoneNumber) {
      newErrors.phoneNumber = "Phone Number is required.";
    } else if (!/^\d{10}$/.test(userProfile.phoneNumber)) {
      newErrors.phoneNumber = "Phone Number must be a valid 10-digit number.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setUserProfile({
      ...userProfile,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "", // Clear error for this field
    });
  };

  const handleSave = async () => {
    if (!validate()) {
      return;
    }
    setApiLoader(true);
    const payload = {
      firstName: userProfile.firstName,
      lastName: userProfile.lastName,
      phoneNumber: userProfile.phoneNumber,
    };
    const queryString = new URLSearchParams(payload).toString();

    try {
      const response = await axios.put(
        `${ENDPOINTS.USER.PROFILE_UPDATE}?${queryString}`,
        fileUploadData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      addToast("Profile updated successfully", "success");
      dispatch(fetchUserProfile({}));
      setApiLoader(false);
    } catch (error) {
      addToast("Failed to update the profile", "error");
      setApiLoader(false);

      console.error("Error updating user profile:", error);
    }
  };

  return (
    <>
      <Header headertitle="Edit" />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      {isLoading ? (
        <div className="spinnerwrapper">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="main-body p-8">
          <div className="max-w-[1218px]">
            <ProfileCard
              name={
                `${userProfile.firstName} ${userProfile.lastName}` ||
                "Dr. Haresh Boghara"
              }
              firstName={userProfile.firstName}
              lastName={userProfile.lastName}
              role={userProfile.role || ""}
              email={userProfile.email || ""}
              image={userProfile.profileImage || ""}
            />

            <form>
              <div className="grid grid-cols-2 gap-8 pt-8">
                <div>
                  <label
                    htmlFor="firstName"
                    className="block form_label_color mb-3"
                  >
                    First Name <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={userProfile.firstName || ""}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm">{errors.firstName}</p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="lastName"
                    className="block form_label_color mb-3"
                  >
                    Last Name <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={userProfile.lastName || ""}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-sm">{errors.lastName}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-8 pt-8">
                <div>
                  <label
                    htmlFor="phoneNumber"
                    className="block form_label_color mb-3"
                  >
                    Phone Number <span className="aestrick_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={userProfile.phoneNumber || ""}
                    onChange={handleChange}
                    disabled={!isEditing}
                    className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="phoneNumber"
                    className="block form_label_color mb-3"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={userProfile.email || "N/A"}
                    disabled
                    className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 cursor-not-allowed bg-gray-100"
                  />
                </div>
                <ImageUploaderUrl
                  selectedImage={selectedImage}
                  setSelectedImage={setSelectedImage}
                  uploadStatus={uploadStatus}
                  setUploadStatus={setUploadStatus}
                  isLoading={isLoadingImage}
                  setIsLoading={setIsLoadingImage}
                  fileUploadData={fileUploadData}
                  setFileUploadData={setFileUploadData}
                />
              </div>
            </form>
          </div>

          <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-4 bottom-0 w-full -ml-8 bg-white pl-8 flex gap-5">
            {isEditing ? (
              <button
                onClick={handleSave}
                type="submit"
                className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px] disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={apiLoader}
              >
                {apiLoader ? (
                  <div className="flex justify-center">
                    <div className="mini-spinner "></div>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setIsEditing(true)}
                className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500"
              >
                Edit
              </button>
            )}
            <BackButton />
          </div>
        </div>
      )}
    </>
  );
};

export default EditPersonalInfo;